export default "__VITE_ASSET__ruNHMKrM__"